import { formatDate } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { CalendarRange } from '@brafton/angular-framework-library';
import { MasterProjectsService } from '@brafton/atlas-api-client';
import { MasterProject, Template } from '@brafton/common-framework-library';
import { Observable } from 'rxjs';

@Component({
  selector: 'shared-create-project-button',
  templateUrl: './create-project-button.component.html',
  styleUrls: ['./create-project-button.component.scss'],
  host: { class: 'create-project-button' },
})
export class SharedCreateProjectButtonComponent {
  @Input() campaignId!: string;
  @Input() masterProjectId?: string;
  templates$: Observable<Template[]>;
  disabled = false;
  expanded = false;
  localProjectName!: string | undefined;
  pauseCollapse = false;
  templateId = '62ec12156964fe35adca720e';

  constructor(private masterProjectsService: MasterProjectsService, private router: Router) {
    this.templates$ = this.masterProjectsService.listTemplates();
  }

  @ViewChild('workflowTemplateId') templateSelector!: MatSelect;
  @ViewChild('newProjectForm', { static: true }) newProjectForm!: NgForm;

  createProject(name: string, open: boolean, date?: Date, workflowId?: string) {
    this.disabled = true;
    const today = formatDate(new Date(), 'd MMM, y', 'en-GB');
    const projectName = name || 'New Production - ' + today;
    const projectDate = date ? CalendarRange.getUTCWorkEnd(date) : null;
    const templateId = workflowId || '62ec12156964fe35adca720e';
    // this.masterProjectsService
    //   .createProject(projectName, templateId, projectDate, null, this.campaignId)
    //   .subscribe((newProject: MasterProject) => {
    //     this.disabled = false;
    //     this.newProjectForm.resetForm();
    //     this.expanded = false;
    //     if (open === true) this.router.navigate([`/projects/${newProject.id}`]);
    //   });
  }
}
